import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    logoUrl: "",
    customerName: "",
    customerRFCID: "",
    state: "",
    city: "",
    zip: "",
    emailRecipents: "",
    invoiceDate: "",
    invoice: "",
    Oredr: "",
    reference: "",
    purchaseOrder: "",
    invoiceDetailsType: "",
    salesTaxPercentage: "",
    salesTaxAmount: "",
    other: "",
    total: ""
};

const invoiceSlice = createSlice({
    name: 'invoice/normal/Fisibility',
    initialState,
    reducers: {
        add_logo_url: (state, { payload }) => {
            state.logoUrl = payload;
        },
        add_entire_data_preview: (state, { payload }) => {
            state.logoUrl = payload?.logoUrl;
            state.customerName = payload?.customerName;
            state.customerRFCID = payload?.customerRFCID;
            state.state = payload?.state;
            state.city = payload?.city;
            state.zip = payload?.zip;
            state.emailRecipents = payload?.emailRecipents;
            state.invoiceDate = payload?.invoiceDate;
            state.invoice = payload?.invoice;
            state.Oredr = payload?.Oredr;
            state.reference = payload?.reference;
            state.purchaseOrder = payload?.purchaseOrder;
            state.invoiceDetailsType = payload?.invoiceDetailsType;
            state.salesTaxPercentage = payload?.salesTaxPercentage;
            state.salesTaxAmount = payload?.salesTaxAmount;
            state.other = payload?.other;
            state.total = payload?.total;
            state.subTotal = payload?.subTotal;
        }
    }
});


export const { add_logo_url, add_entire_data_preview } = invoiceSlice.actions;

export default invoiceSlice;